import React from 'react';
import { Alert, AlertTitle } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

interface AppSnackbarAlertProps {
    message: string;
    severity: 'error' | 'warning' | 'info' | 'success';
    open: boolean;
    onClose: () => void; 
    autoHideDuration?: number;
}

const severityTitles: { [key in AppSnackbarAlertProps['severity']]: string } = {
    error: 'Erro',
    warning: 'Atenção',
    info: 'Informativo',
    success: 'Sucesso',
};

export const AppSnackbarAlert: React.FC<AppSnackbarAlertProps> = ({ message, severity, open, onClose, autoHideDuration = 6000 }) => {
    return (
        <Snackbar open={open} autoHideDuration={autoHideDuration} onClose={onClose}>
            <Alert severity={severity} variant="filled" onClose={onClose}>
                <AlertTitle>{severityTitles[severity]}</AlertTitle>
                {message}
            </Alert>
        </Snackbar>
    );
};